export const config = {
  apiHost: process.env.REACT_APP_API_HOST || 'https://cg-api.techwiz.tech',
  adminUserName: process.env.REACT_APP_ADMIN_USERNAME || 'admin',
  adminPassword: process.env.REACT_APP_ADMIN_PASSWORD || 'Password1'
}
